import React, { useState } from 'react';
import './App.css';
import { Layout } from './components/Layout';


import { Contact } from './pages/Contact';
import { Blog} from './pages/Blog';
import { Root } from './pages/Root';
import { ThemeContext } from './components/ThemeContext';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { BlogDetail } from './pages/Blog/BlogDetail';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useEffect } from 'react';



import './i18n/i18n';
import { useTranslation } from 'react-i18next';

const muiTheme = createTheme({
  typography: {
    fontFamily: '"League Spartan", sans-serif',
    // Apply to all typography variants
    h1: {
      fontFamily: '"League Spartan", sans-serif',
    },
    h2: {
      fontFamily: '"League Spartan", sans-serif',
    },
    h3: {
      fontFamily: '"League Spartan", sans-serif',
    },
    body1: {
      fontFamily: '"League Spartan", sans-serif',
    },
    body2: {
      fontFamily: '"League Spartan", sans-serif',
    },
    button: {
      fontFamily: '"League Spartan", sans-serif',
    },
  },
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          fontFamily: '"League Spartan", sans-serif',
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          fontFamily: '"League Spartan", sans-serif',
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          fontFamily: '"League Spartan", sans-serif',
        },
      },
    },
  },
 
});

const App = () => {
  const [theme, setTheme] = useState<"light" | "dark">("light");
  //Change html attribute lang
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <MuiThemeProvider theme={muiTheme}> 
    
    <CssBaseline />
  
    <ThemeContext.Provider value={[theme, setTheme] }>
      <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Root />} />
              <Route path="contact" element={<Contact />} />
              <Route path="blog" element={<Blog />} />
              <Route path="blog/:slug" element={<BlogDetail />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeContext.Provider>
      
        </MuiThemeProvider>
  );
}

export default App;
